import {
  CHAT_FOLDER_LIST_QUERY_KEY,
  DEFAULT_CHAT_FOLDER_LIST_LIMIT,
  DEFAULT_CHAT_FOLDER_LIST_OFFSET,
} from "@frontend-shared/constants";
import type { IChatFolderListObject } from "@frontend-shared/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { chatFolderApi } from "@/api/services";

export const useChatFolderList = (): {
  data: IChatFolderListObject[];
  isLoading: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
} => {
  const query = useInfiniteQuery({
    queryKey: [CHAT_FOLDER_LIST_QUERY_KEY],
    queryFn: async ({ pageParam }) => {
      const limit = DEFAULT_CHAT_FOLDER_LIST_LIMIT;
      const offset = pageParam * limit;
      return chatFolderApi.getChatFolderList({ limit, offset });
    },
    initialPageParam: DEFAULT_CHAT_FOLDER_LIST_OFFSET,
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.hasNextPage ? allPages.length : undefined;
    },
  });

  const data = useMemo(
    (): IChatFolderListObject[] =>
      query.data?.pages.flatMap((page) => page.data) ?? [],
    [query.data],
  );

  return {
    data,
    isLoading: query.isLoading,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
  };
};
